import type { Step } from 'react-joyride'

interface RoleFlags {
  isAdmin: boolean
  canManageUsers: boolean
  isIntern: boolean
  isOfficeSupport: boolean
  isConsultant: boolean
}

type PortalStep = Step & {
  roleFilter?: (roles: RoleFlags) => boolean
}

// Kept lean on purpose. The beta consultants didn't use Replet — they're
// learning a standard workflow for the first time. Don't drown them in nav
// detail; deep pages get their own page-level tour on first visit.
const allPortalSteps: PortalStep[] = [
  {
    target: '[data-tour="sidebar-brand"]',
    title: 'Welcome to YieldOS',
    content: 'This is your portal. You\'ll build a recommendation, turn it into a quote, then submit an order — all in one place.',
    skipBeacon: true,
    placement: 'right',
  },
  {
    target: '[data-tour="nav-farmers"]',
    title: 'Step 1 — Your farmers',
    content: 'Add a farmer here before you start. Their soil tests and history live on this page.',
    skipBeacon: true,
    placement: 'right',
  },
  {
    target: '[data-tour="nav-recommendations"]',
    title: 'Step 2 — Build a recommendation',
    content: 'This is the main thing you\'ll do. Pick a farmer, answer a short questionnaire, get a personalized plan.',
    skipBeacon: true,
    placement: 'right',
  },
  {
    target: '[data-tour="nav-quotes"]',
    title: 'Step 3 — Turn it into a quote',
    content: 'Once the recommendation is right, create a quote from it. Pricing pulls in automatically.',
    skipBeacon: true,
    placement: 'right',
    roleFilter: (roles) => !roles.isIntern,
  },
  {
    target: '[data-tour="nav-orders"]',
    title: 'Step 4 — Submit the order',
    content: 'When the farmer says yes, the quote becomes an order. Track fulfillment from here.',
    skipBeacon: true,
    placement: 'right',
    roleFilter: (roles) => !roles.isIntern,
  },
  {
    target: '[data-tour="take-a-tour-btn"]',
    title: 'Need a refresher?',
    content: 'Click here any time to replay this tour. We\'ll also walk you through new pages the first time you open them.',
    skipBeacon: true,
    placement: 'right',
  },
]

export function getPortalSteps(roles: RoleFlags): Step[] {
  return allPortalSteps
    .filter((step) => !step.roleFilter || step.roleFilter(roles))
    .map(({ roleFilter: _, ...step }) => step)
}
